import { render, staticRenderFns } from "./production-bran-percentage-graph.vue?vue&type=template&id=522741a8&scoped=true&"
import script from "./production-bran-percentage-graph.vue?vue&type=script&lang=js&"
export * from "./production-bran-percentage-graph.vue?vue&type=script&lang=js&"
import style0 from "./production-bran-percentage-graph.vue?vue&type=style&index=0&id=522741a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522741a8",
  null
  
)

export default component.exports